const ListingsCategory = [
  {
    "category": "House-Holds",
    "options": [
      "Dinning-Set",
      "Comfortable-Chair",
      "Wall-Paper",
      "Window-Blind",
      "Railing",
      "Center-Table",
      "Door",
      "Bedding",
      "CupBoard",
      "Roofing Sheets",
      "Wall Consoles",
      "Wall Panels",
      
    ]
  },
  {
    "category": "More-HouseHolds",
    "options": [
      "Lightenings", "Side Sofas", "Throw pilows", "Wall Frames", "Wardrobes", 
      "Rocking Chairs", "Dress Tables", "Gym Equipment", "Reading Desks",
      "Art-Works", "Gaming"
    ]
  },
  {
    "category": "Real-Estate",
    "options": [
      "Land", "Private Residence", "Apartment", "Office Space", "Commercial Property",
    ]
  },
  {
    "category": "Skilled-Labour",
    "options": [
      "Electrician", "Plumber", "Delivery", 
      "Care-Giver", "Interior Fitters", "Painter", "SPA Treatment", "Security Services"
    ]
  },
  {
    "category": "Pet",
    "options": [
      "Dog",
      "Cat",
      "Bird",
      "Aquarium",
      "Toys",
    ]
  },
  
]
export default ListingsCategory;